import { useSnackbar } from "notistack";

export const isNumber = (value) => {
  return typeof value === 'number' && isFinite(value);
}

export const isEqual = (left, right) => {
  return JSON.stringify(left) == JSON.stringify(right);
}

export const isEmpty = (obj) => {
  return Object.keys(obj).length === 0;
}

export const checkFieldCondition = (input, formData) => {
  if (!input.condition) return true;
  if (input.condition.type === "regexp" && (new RegExp((input.condition.value + "").split("/").join(""))).test(formData[input.condition.field]) == false) {
    return false;
  }
  if (input.condition.type === "bool" && (!!input.condition.value !== !!(formData[input.condition.field]))) {
    return false;
  }
  return true
}

export const getCardType = (number) => {
  if (number.startsWith('2')) {
    return 'mir'
  } else return 'visamastercard'
}

export const luhnCheck = (function (arr) {
  return function (ccNum) {
    var
      len = ccNum.length,
      bit = 1,
      sum = 0,
      val;

    while (len) {
      val = parseInt(ccNum.charAt(--len), 10);
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
  };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

export const sendFormData = function (url, data, method, target) {
  var form = document.createElement('form');
  form.method = method || 'POST';
  form.action = url;
  form.target = target || "_self";
  for (var key in data) {
    var input = document.createElement('input');
    input.name = key;
    input.value = data[key];
    input.type = 'hidden';
    form.appendChild(input)
  }
  document.body.appendChild(form);
  form.submit();
}

export const numberFormat = function (number) {
  const result = Number(number).toLocaleString()
  return result.replace(/\,/, ".");
}

var TEXT = {}

export const setDict = function (data, setGreenScreen = () => { }) {
  TEXT = data;
  setGreenScreen();
}

// export const setDict = function (data = {}, setGreenScreen = () => {}) {
//   const dictionary = localStorage.getItem("dictionary");
//   if (dictionary && dictionary.length > 0) {
//     TEXT = { ...JSON.parse(dictionary) };
//     TEXT.version !== 13 && getDictionary(data, setGreenScreen);
//     setGreenScreen(false);
//   } else {
//     getDictionary(data, setGreenScreen);
//   }
// };

// const getDictionary = async (data, setGreenScreen) => await fetch(`/crypster.json`)
// .then((response) => response.json())
// .then((out) => {
//   TEXT = { ...data, ...out };
//   localStorage.setItem("dictionary", JSON.stringify(TEXT));
//   setGreenScreen(false);
// });

window.showDict = () => {
  if (localStorage.debugmode == "dict") {
    localStorage.debugmode = "off";
    window.setLang("ru")
  } else {
    localStorage.debugmode = "dict";
    window.setLang("dict")
  }
}

export const getLang = () => {
  const qParams = new URLSearchParams(window.location.search);
  let linkLang
  if (qParams.get('lang')) {
    linkLang = qParams.get('lang').toLowerCase() === "en" ? "en" : "ru";
  }
  const browserLang = navigator.language.split("-")[0] == 'ru' ? 'ru' : 'en';
  const savedLang = localStorage.lang;
  const resultLang = linkLang || savedLang || browserLang || "ru";
  return resultLang
}

export const getText = function (value) {
  if (localStorage.debugmode == "dict") {
    return value;
  }
  let lang = (localStorage.lang || "ru").toLowerCase();
  if (!Object.getOwnPropertyNames(TEXT).length) { return value }
  if (value === "") {
    return value;
  } else if (TEXT[value] === undefined || TEXT[value][lang] === undefined || TEXT[value][lang] == "") {
    return value;
  } else {
    return TEXT[value][lang] || TEXT[value]["RU"];
  }
}

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export const formatDate = (data) => {
  const year = data.getFullYear();
  const month = ("0" + (data.getMonth() + 1)).slice(-2);
  const date = ("0" + data.getDate()).slice(-2);
  const hours = ("0" + data.getHours()).slice(-2);
  const minutes = ("0" + data.getMinutes()).slice(-2);
  return `${date}.${month}.${year} ${hours}:${minutes}`;
}

export const trimString = (str, countLetters) => {
  if (typeof str !== "string") return str;
  if (str.includes('***') || str.includes('...')) return str;

  if (countLetters) {
    return str.length > countLetters * 2
      ? `${str.slice(0, countLetters)} ... ${str.slice(-countLetters)}`
      : str;
  } else {
    if (str.length > 16) {
      return `${str.slice(0, 6)} ... ${str.slice(-6)}`;
    } else if (str.length > 8 && str.length <= 16) {
      return `${str.slice(0, 4)} ... ${str.slice(-4)}`;
    } else {
      return str;
    }
  }
};

export const currencyNetf = (network, currency) => {
  if (network == currency) {
    return ""
  } else {
    if (network) { return ` ${network}` } else { return "" }
  }
}

export const trimCardForMobile = (str) => {
  if (typeof str !== "string" || !str.includes('...')) return str;

  return `${str.slice(0, 6)} ... ${str.slice(-6)}`;
};

export const openSocAuth = (socialLinks, system) => {
  const h = 800;
  const w = 800;
  const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
  const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);

  window.open(
    socialLinks[system],
    "auth",
    `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
  width=800,height=800,top=${y}, left=${x}`
  );
};

export const formatCardNumber = (str, paymentType) => {
  if (!str) return str;
  if (typeof str !== "string") str.toString();
  if (str.includes('***') || str.includes('...') || str.includes('+')) return str;

  if (!paymentType || (paymentType && paymentType === 'BANK')) {
    return str.match(/.{1,4}/g).join(" ");
  }
  else
    return str;
}

export const getRoundedFromSum = (fromSum, fromMultiple) => {
  return fromSum - (fromSum % fromMultiple)
}

/**
 * Calculates the rounded sum based on the type provided.
 *
 * @param {number} dirSum - The sum to be rounded.
 * @param {number} toMultiple - The multiple to round to.
 * @param {string} type - The type of rounding ('up' for ceiling, 'math' for standard rounding).
 * @return {number} The rounded sum based on the specified type.
 */
export const getRoundedDirSum = (dirSum, toMultiple, type) => {
  // return dirSum - (dirSum % toMultiple === 0 ? 0 : (dirSum % toMultiple) - 10);
  if (type === 'up') {
    return Math.ceil(dirSum / toMultiple) * toMultiple;
  } else if (type === 'math') {
    return Math.round(dirSum / toMultiple) * toMultiple;
  }
  return Math.ceil(dirSum / toMultiple) * toMultiple;
}


/**
 * Rounds a sum up to the nearest multiple.
 *
 * @param {number} sum - The sum to be rounded.
 * @param {number} multiple - The multiple to round up to.
 * @return {number} The rounded sum.
 */
export const roundSumWithMultiple = (sum, multiple) => {
  return Math.round(sum / multiple) * multiple
}

/**
 * Rounds a given sum to the nearest multiple within the specified limits.
 *
 * @param {number} sum - The sum to be rounded.
 * @param {number} multiple - The multiple to round up to.
 * @param {number} min - The minimum limit for the rounded sum.
 * @param {number} max - The maximum limit for the rounded sum.
 * @return {number} The rounded sum, ensuring it is within the specified limits.
 */
export const roundSumWithMultipleBetweenLimits = (sum, multiple, min, max) => {
  const roundedSum = Math.round(sum / multiple) * multiple

  if (roundedSum < min) {
    if (min % multiple !== 0) return Number(roundedSum) + Number(multiple)
    else return min
  }
  if (roundedSum > max) {
    if (max % multiple !== 0) return Number(roundedSum) - Number(multiple)
    else return max
  }

  return roundedSum
}

export function declOfNum(n = 1500, text_forms) {
  n = Math.abs(n) % 100;
  var n1 = n % 10;
  if (n > 10 && n < 20) { return text_forms[2]; }
  if (n1 > 1 && n1 < 5) { return text_forms[1]; }
  if (n1 == 1) { return text_forms[0]; }
  return text_forms[2];
}

export function useClipboard() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showMessage = () => {
    enqueueSnackbar(getText("copied"), { variant: 'info' });
  };

  const copyToClipboard = (event) => {
    if (event.target) {
      var copyText = event.target;
      navigator.clipboard.writeText(copyText.innerText);
      showMessage();
    }
  }

  return copyToClipboard
}

export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
}